import { combineReducers } from "@reduxjs/toolkit";
import searchReducer from "./search.reducer";
import { appReducer } from "./app.reducer";
// import { cartReducer } from "./cart.reducer";

const rootReducer = combineReducers({
  app: appReducer,
  // cart: cartReducer,
  search: searchReducer,
});

export default rootReducer;
